<script setup>
</script>

<template>
    <svg
        width="12"
        height="6"
        viewBox="0 0 12 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.82414 5.82594C5.92156 5.92236 6.07844 5.92236 6.17586 5.82594L11.6301 0.427686C11.7888 0.270571 11.6775 0 11.4542 0H0.545803C0.322455 0 0.211197 0.270571 0.36994 0.427686L5.82414 5.82594Z"
            fill="#6B7280"
        />
    </svg>
</template>
